<nav class="article-nav">
  <strong class="article-nav__category-name">{{selectedCategory?.title}}</strong>

  <div class="article-nav__actions">
    <div class="article-nav__controls">
      <dds-button class="article-nav__btn article-nav__btn_prev"
                  icon="dds-icon_arrow_left__s__stroke"
                  theme="dark"
                  kind="primary"
                  [size]="currentDevice === EDevices.desktop ? 'md' : 'lg'"
                  [isIconLeft]="true"
                  [disabled]="activeArticleIndex === 0"
                  [ddsTooltip]="articlePreview"
                  [tooltipCustomClass]="previewTooltip.tooltipCustomClass"
                  [tooltipTheme]="previewTooltip.tooltipTheme"
                  [tooltipIsInverse]="previewTooltip.tooltipIsInverse"
                  [tooltipWidth]="previewTooltip.tooltipWidth"
                  [tooltipIsDisabled]="currentDevice !== EDevices.desktop"
                  tooltipPosition="top-left"
                  (mouseenter)="setPreviewArticleData(activeArticleIndex - 1)"
                  (clicked)="goToArticle(selectedCategory?.list[activeArticleIndex - 1])">
        Previous
      </dds-button>

      <dds-button class="article-nav__btn article-nav__btn_next"
                  icon="dds-icon_arrow_right__s__stroke"
                  theme="dark"
                  kind="primary"
                  [size]="currentDevice === EDevices.desktop ? 'md' : 'lg'"
                  [disabled]="activeArticleIndex === selectedCategory?.list.length - 1"
                  [ddsTooltip]="articlePreview"
                  [tooltipCustomClass]="previewTooltip.tooltipCustomClass"
                  [tooltipTheme]="previewTooltip.tooltipTheme"
                  [tooltipIsInverse]="previewTooltip.tooltipIsInverse"
                  [tooltipWidth]="previewTooltip.tooltipWidth"
                  [tooltipIsDisabled]="currentDevice !== EDevices.desktop"
                  tooltipPosition="top-right"
                  (mouseenter)="setPreviewArticleData(activeArticleIndex + 1)"
                  (clicked)="goToArticle(selectedCategory?.list[activeArticleIndex + 1])">
        Next
      </dds-button>
    </div>

    <div class="article-nav-dots">
      @for (item of selectedCategory?.list; track item; let index = $index) {
      <button class="article-nav-dots__item"
              [class.active]="index === activeArticleIndex"
              [disabled]="index === activeArticleIndex"
              [ddsTooltip]="articlePreview"
              [tooltipCustomClass]="previewTooltip.tooltipCustomClass"
              [tooltipTheme]="previewTooltip.tooltipTheme"
              [tooltipIsInverse]="previewTooltip.tooltipIsInverse"
              [tooltipWidth]="previewTooltip.tooltipWidth"
              [tooltipIsDisabled]="currentDevice !== EDevices.desktop"
              tooltipPosition="top"
              (mouseenter)="setPreviewArticleData(index)"
              (click)="goToArticle(selectedCategory?.list[index])"></button>
      }
    </div>
  </div>

  <i class="article-nav__line"
     [ngStyle]="{
       'background': 'linear-gradient(90deg, '+themeSettings.gradient[0]+' 0%, '+themeSettings.gradient[1]+' 100%)'
     }"></i>
</nav>

<ng-template #articlePreview>
  <div class="article-preview">
    <strong class="article-preview__title">{{previewArticleData?.title}}</strong>
  </div>
</ng-template>
